import PropTypes from "prop-types";
import { displayModeContext } from "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
const { Provider: DisplayModeProvider } = displayModeContext;
DisplayModeProvider.propTypes = {
  value: PropTypes.oneOf(["dark", "light"]).isRequired
};
export {
  DisplayModeProvider
};
